import { defineMessages } from 'react-intl';

const messages = defineMessages({
  title: {
    id: 'LessonDetails.Attachments.title',
    defaultMessage: 'Attachments',
  },
  type: {
    id: 'LessonDetails.Attachments.type',
    defaultMessage: 'Type:',
  },
  size: {
    id: 'LessonDetails.Attachments.size',
    defaultMessage: 'Size:',
  },
  uploaded: {
    id: 'LessonDetails.Attachments.uploaded',
    defaultMessage: 'Uploaded:',
  },
  download: {
    id: 'LessonDetails.Attachments.download',
    defaultMessage: 'Download',
  },
  open: {
    id: 'LessonDetails.Attachments.open',
    defaultMessage: 'Open',
  },
});

export default messages;
